import _ from 'lodash'

const formatUrl = (path, version, partnerPath) => {
  const adjustedPath = path[0] !== '/' ? '/' + path : path
  if (_.startsWith(path, 'http')) return path
  const apiPath = partnerPath
    ? adjustedPath
    : `/api/${version || 'v1'}${adjustedPath}`
  if (process.env.NODE_ENV === 'production') {
    if (process.env.REACT_APP_ENV === 'staging')
      return `https://api-staging.fitonapp.com${apiPath}`
    return `https://api.fitonapp.com${apiPath}`
  } else {
    return `https://api-staging.fitonapp.com${apiPath}`
  }
}
export default formatUrl

export const isProduction = () => {
  if (process.env.NODE_ENV === 'production') {
    if (process.env.REACT_APP_ENV === 'staging') return false
    return true
  } else {
    return false
  }
}

export const getAPICachePath = (path, version) => {
  const adjustedPath = path[0] !== '/' ? '/' + path : path
  const apiPath = `/api/${version || 'v1'}${adjustedPath}`
  if (process.env.NODE_ENV === 'production') {
    if (process.env.REACT_APP_ENV === 'staging')
      return `https://api-staging.fitonapp.com${apiPath}`
    return `https://api-cache.fitonapp.com${apiPath}`
  } else {
    return `https://api-staging.fitonapp.com${apiPath}`
  }
}
